// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-pill-planning {
  display: flex;
  justify-content: space-between;
  padding: 40px 16px 16px 16px;
  gap: 20px;
}
@media (min-width: 560px) {
  .box-pill-planning {
    padding-top: 15px;
  }
}
@media (min-width: 1024px) {
  .box-pill-planning {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (min-width: 1280px) {
  .box-pill-planning {
    padding-left: 80px;
    padding-right: 80px;
    padding-bottom: 50px;
  }
}
@media (min-width: 1920px) {
  .box-pill-planning {
    justify-content: space-evenly;
  }
}
@media (max-width: 1300px) {
  .box-pill-planning {
    flex-direction: column;
  }
}
.box-pill-planning .pill-planning-left {
  display: flex;
  flex-direction: column;
}
@media (min-width: 1300px) {
  .box-pill-planning .pill-planning-left {
    max-width: 720px;
  }
}
.box-pill-planning .pill-planning-left .h4-pad {
  padding: 24px 0;
}
@media (max-width: 1300px) {
  .box-pill-planning .pill-planning-left__container .block-how-to-use {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.box-pill-planning .pill-planning-left__container .block-how-to-use__accordion {
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}
.box-pill-planning .pill-planning-left__container .block-how-to-use__hidden-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease;
}
.box-pill-planning .pill-planning-left__container .block-how-to-use__hidden-content ul {
  padding: 0 15px;
  list-style: decimal;
}
.box-pill-planning .pill-planning-left__container .block-how-to-use__hidden-content ul li {
  padding: 10px 5px;
}
.box-pill-planning .pill-planning-left__container .block-how-to-use__hidden-content p {
  padding: 5px 0;
}
.box-pill-planning .pill-planning-left__container .block-how-to-use__hidden-content.open {
  max-height: 500px;
}
.box-pill-planning .pill-planning-left__container .block-how-to-use__desktop {
  margin-bottom: 16px;
}
.box-pill-planning .pill-planning-left__container .block-how-to-use__desktop span {
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
}
@media (max-width: 992px) {
  .box-pill-planning .pill-planning-left__container .block-how-to-use__desktop {
    display: none;
  }
}
.box-pill-planning .pill-planning-left__container .block-how-to-use button {
  margin-top: 24px;
}
.box-pill-planning .pill-planning-left__container .line {
  flex-grow: 1;
  height: 1px;
  background-color: var(--sebrae-light-gray-2);
  margin: 32px 10px;
}
@media (min-width: 1301px) {
  .box-pill-planning .pill-planning-left__container .line {
    display: none;
  }
}
.box-pill-planning .pill-planning-right {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.box-pill-planning .pill-planning-right::before {
  content: "";
  position: absolute;
  left: -20px;
  top: 50px;
  bottom: 0;
  width: 2px;
  background-color: var(--sebrae-light-gray-2);
}
@media (max-width: 1319px) {
  .box-pill-planning .pill-planning-right::before {
    left: -15px;
  }
}
.box-pill-planning .pill-planning-right__content {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 16px;
}
.box-pill-planning .pill-planning-right__content .pills-cards {
  gap: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1300px) {
  .box-pill-planning .pill-planning-right__content .pills-cards a {
    display: flex;
    justify-content: center;
  }
}
.box-pill-planning .pill-planning-right__content .pills-cards .video {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px;
  max-width: 357px;
  min-height: 207px;
  border-radius: 4.91px 24.54px 24.54px 24.54px;
  background-color: #fff;
  box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);
}
.box-pill-planning .pill-planning-right__content .pills-cards .image {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 357px;
  min-height: 184px;
}
.box-pill-planning .pill-planning-right__content .see-all {
  color: #006bff;
  text-decoration: underline;
  display: flex;
  justify-content: center;
}
.box-pill-planning .pill-planning-right__content .see-all:hover {
  filter: contrast(5);
}
@media (min-width: 1301px) {
  .box-pill-planning .pill-planning-right {
    width: 30%;
    padding-top: 52px;
  }
  .box-pill-planning .pill-planning-right__content {
    max-width: 357px;
  }
  .box-pill-planning .pill-planning-right__mobile {
    display: none;
  }
}
@media (max-width: 1300px) {
  .box-pill-planning .pill-planning-right__desktop {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/box-pill-planning/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,4BAAA;EACA,SAAA;AACF;AACE;EANF;IAOI,iBAAA;EAEF;AACF;AADE;EATF;IAWK,kBAAA;IACA,mBAAA;EAGH;AACF;AADE;EAfF;IAiBM,kBAAA;IACA,mBAAA;IACA,oBAAA;EAGJ;AACF;AAAE;EAvBF;IAwBI,6BAAA;EAGF;AACF;AADE;EA3BF;IA4BI,sBAAA;EAIF;AACF;AAFE;EACE,aAAA;EACA,sBAAA;AAIJ;AAFI;EAJF;IAKI,gBAAA;EAKJ;AACF;AAHI;EACE,eAAA;AAKN;AAAQ;EADF;IAEI,aAAA;IACA,sBAAA;IACA,mBAAA;EAGR;AACF;AADQ;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AAGV;AAAQ;EACE,aAAA;EACA,gBAAA;EACA,gCAAA;AAEV;AAAU;EACE,eAAA;EACA,mBAAA;AAEZ;AAAY;EACE,iBAAA;AAEd;AAEU;EACE,cAAA;AAAZ;AAGU;EACE,iBAAA;AADZ;AAKQ;EACE,mBAAA;AAHV;AAKU;EACE,eAAA;EACA,0BAAA;EACA,iBAAA;AAHZ;AAMU;EATF;IAUI,aAAA;EAHV;AACF;AAMQ;EACE,gBAAA;AAJV;AAQM;EACE,YAAA;EACA,WAAA;EACA,4CAAA;EACA,iBAAA;AANR;AAQQ;EANF;IAOI,aAAA;EALR;AACF;AAUE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AARJ;AAUI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,4CAAA;AARN;AAWI;EACE;IACE,WAAA;EATN;AACF;AAYI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AAVN;AAYM;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAVR;AAYQ;EACE;IACE,aAAA;IACA,uBAAA;EAVV;AACF;AAaQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,6CAAA;EACA,sBAAA;EACA,6CAAA;AAXV;AAcQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAZV;AAgBM;EACE,cAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;AAdR;AAgBQ;EACE,mBAAA;AAdV;AAmBI;EA5EF;IA6EI,UAAA;IACA,iBAAA;EAhBJ;EAkBI;IACE,gBAAA;EAhBN;EAmBI;IACE,aAAA;EAjBN;AACF;AAqBM;EADF;IAEI,aAAA;EAlBN;AACF","sourcesContent":[".box-pill-planning {\n  display: flex;\n  justify-content: space-between;\n  padding: 40px 16px 16px 16px;\n  gap: 20px;\n\n  @media (min-width: 560px) {\n    padding-top: 15px;\n  }\n  @media (min-width: 1024px) {\n    padding: {\n     left: 30px;\n     right: 30px;\n    }\n  }\n  @media (min-width: 1280px) {\n    padding: {\n      left: 80px;\n      right: 80px;\n      bottom: 50px;\n    }\n  }\n\n  @media (min-width: 1920px) {\n    justify-content: space-evenly;\n  }\n\n  @media (max-width: 1300px) {\n    flex-direction: column;\n  }\n\n  .pill-planning-left {\n    display: flex;\n    flex-direction: column;\n\n    @media (min-width: 1300px) {\n      max-width: 720px;\n    }\n\n    .h4-pad {\n      padding: 24px 0;\n    }\n\n    &__container {\n      .block-how-to-use {\n        @media (max-width: 1300px) {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n        }\n\n        &__accordion {\n          display: flex;\n          justify-content: space-between;\n          width: 100%;\n          cursor: pointer;\n        }\n\n        &__hidden-content {\n          max-height: 0;\n          overflow: hidden;\n          transition: max-height 0.5s ease;\n\n          ul {\n            padding: 0 15px;\n            list-style: decimal;\n\n            li {\n              padding: 10px 5px;\n            }\n          }\n\n          p {\n            padding: 5px 0;\n          }\n\n          &.open {\n            max-height: 500px;\n          }\n        }\n\n        &__desktop {\n          margin-bottom: 16px;\n\n          span {\n            cursor: pointer;\n            text-decoration: underline;\n            font-weight: bold;\n          }\n\n          @media (max-width: 992px) {\n            display: none;\n          }\n        }\n\n        button {\n          margin-top: 24px;\n        }\n      }\n\n      .line {\n        flex-grow: 1;\n        height: 1px;\n        background-color: var(--sebrae-light-gray-2);\n        margin: 32px 10px;\n\n        @media (min-width: 1301px) {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .pill-planning-right {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: -20px;\n      top: 50px;\n      bottom: 0;\n      width: 2px;\n      background-color: var(--sebrae-light-gray-2);\n    }\n\n    @media (max-width: 1319px) {\n      &::before {\n        left: -15px;\n      }\n    }\n\n    &__content {\n      display: flex;\n      align-items: center;\n      flex-direction: column;\n      padding-top: 16px;\n\n      .pills-cards {\n        gap: 16px;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n\n        @media (max-width: 1300px) {\n          a {\n            display: flex;\n            justify-content: center;\n          }\n        }\n\n        .video {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          padding: 16px;\n          max-width: 357px;\n          min-height: 207px;\n          border-radius: 4.91px 24.54px 24.54px 24.54px;\n          background-color: #fff;\n          box-shadow: 0 4px 4px 2px rgba(0, 0, 0, 0.05);\n        }\n\n        .image {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          max-width: 357px;\n          min-height: 184px;\n        }\n      }\n\n      .see-all {\n        color: #006bff;\n        text-decoration: underline;\n        display: flex;\n        justify-content: center;\n\n        &:hover {\n          filter: contrast(5);\n        }\n      }\n    }\n\n    @media (min-width: 1301px) {\n      width: 30%;\n      padding-top: 52px;\n\n      &__content {\n        max-width: 357px;\n      }\n\n      &__mobile {\n        display: none;\n      }\n    }\n\n    &__desktop {\n      @media (max-width: 1300px) {\n        display: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
